// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__G9CRL","label":"styles_label__2j2ZW"};